export default "__VITE_PUBLIC_ASSET__b0f8746b__"